import React from "react";
import "./index.scss";

const Stepper = ({ currentStep }) => {
  const steps = [
    { id: 1, label: "Entrer Email" },
    { id: 2, label: "Entrer Le Code" },
    { id: 3, label: "Réinitialiser" },
  ];

  return (
    <div className="md-stepper-horizontal orange">
      {steps.map((step, index) => {
        const isActive = currentStep >= step.id;
        const isDone = currentStep > step.id;
        const isEditable = currentStep === step.id + 1;

        return (
          <div
            key={step.id}
            className={`md-step ${isActive ? "active" : ""} ${
              isDone ? "done" : ""
            } ${isEditable ? "editable" : ""}`}
          >
            <div className={`md-step-circle ${isActive ? "active" : ""}`}>
              <span>{step.id}</span>
            </div>
            <div className={`md-step-title ${isActive ? "active" : ""}`}>
              {step.label}
            </div>
            <div
              className={`md-step-bar-left ${isDone ? "completed" : ""}`}
            ></div>
            <div
              className={`md-step-bar-right ${isDone ? "completed" : ""}`}
            ></div>
          </div>
        );
      })}
    </div>
  );
};

export default Stepper;
